module.exports = __webpack_public_path__ + "img/09.b1e24f26.jpg";